import { Action } from '../../../shared/xs/actions';
import { UserToInviteModel } from '../../invite/user-to-invite.model';

export class UpdateCompanyProfileUserAction implements Action {
  static readonly type = '[CompanyProfile] Invite Users';

  constructor(public payload: UserToInviteModel[]) {}
}
